import { render, staticRenderFns } from "./cost-main.vue?vue&type=template&id=6faa859c&scoped=true&"
import script from "./cost-main.vue?vue&type=script&lang=js&"
export * from "./cost-main.vue?vue&type=script&lang=js&"
import style0 from "./cost-main.vue?vue&type=style&index=0&id=6faa859c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa859c",
  null
  
)

export default component.exports